module.exports = __webpack_public_path__ + "img/login.552d3754.svg";